import {
  GET_USERS,
  UPDATE_USER,
  GET_USERS_WITH_ID,
  CANCEL_USERS,
  CREATE_USER,
  UPDATE_USER_STATUS,
  GET_CUSTOMERS,
  GET_ORGANS,
  POST_ORGANS,
} from './constants';
import {cancelPayload, PayloadUpdate, PayloadCreate} from './interfaces';

export function getUsersAction(payload: object) {
  return {
    type: GET_USERS,
    payload,
  };
}
export function getCustomersAction(payload: object) {
  return {
    type: GET_CUSTOMERS,
    payload,
  };
}
export function postOrgansAction(payload: object) {
  return {
    type: POST_ORGANS,
    payload,
  };
}
export function getOrgansAction(payload: object) {
  return {
    type: GET_ORGANS,
    payload,
  };
}

export function getUserWithIdAction(payload: {id: number}) {
  return {
    type: GET_USERS_WITH_ID,
    payload,
  };
}

export function updateUserActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_USER,
    payload,
  };
}

export function createUserActions(payload: PayloadCreate) {
  return {
    type: CREATE_USER,
    payload,
  };
}

export function cancelUserActions(payload: cancelPayload) {
  return {
    type: CANCEL_USERS,
    payload,
  };
}

export function updateUserStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_USER_STATUS,
    payload,
  };
}
